const registrationEn = {
    studentInstituteEnrollment: require('../../lang/en/registration/StudentInstituteEnrollment').default,
};

export default registrationEn;
